"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("@mui/material"),t=require("./code.org/index.js");function a(e){return r.createTheme(t,{palette:{primary:e}})}exports.createBrandTheme=a;
//# sourceMappingURL=createBrandTheme.js.map
